import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const interviewSession = createSlice({
  name: 'interviewSession',
  initialState,
  reducers: {
    setInterviewSession: handlers.setInterviewSession,
  },
});

export const { actions, reducer } = interviewSession;

export const { setInterviewSession } = actions;

export default reducer;
